import "./css/index.css";
import React, { FC } from "react";
import classNames from "classnames";
import { ODSBreadcrumbSeparatorDotProps } from "./ODSBreadcrumb.types";

const ODSBreadcrumbSeparatorDot: FC<ODSBreadcrumbSeparatorDotProps> = ({
  className,
  ...rest
}) => {
  return (
    <span
      className={classNames(`ODSBreadcrumbSeparatorDot`, className)}
      {...rest}
    >
      &#183;
    </span>
  );
};

export default ODSBreadcrumbSeparatorDot;
